import { useCallback, useState } from 'react'
import { useRootStore } from './rootStore'

export function useRouter() {
  return useRootStore().router
}

export function useQueryParams() {
  return useRouter().queryParams
}

function useSafeQueryParams() {
  return useRouter().queryParams ?? {}
}

export function useQueryParamsState<T extends string>(
  key: string,
  initialValue?: T
) {
  const rootStore = useRootStore()
  const queryParams = useSafeQueryParams()
  const initialQueryParam = queryParams[key] as T | undefined

  const [value, _setValue] = useState<T | null>(
    initialValue || initialQueryParam || null
  )

  const setValue = useCallback(
    (newValue: T | null | ((oldValue: T | null) => T | null)) => {
      const finalValue =
        typeof newValue === 'function' ? newValue(value) : newValue

      rootStore.updateQueryParams(
        { [key]: finalValue || undefined },
        {
          replaceHistory: true,
        }
      )
      _setValue(finalValue)
    },
    [key, rootStore, value]
  )

  return [value, setValue] as const
}
